var exports = {
  "kL": "xdbfd91f1--8a3b36--container",
  "Sr": "xdbfd91f1--8a3b36--container--open",
  "OS": "xdbfd91f1--8a3b36--more",
  "Qq": "xdbfd91f1--8a3b36--text",
};

module.exports = exports;
